<template>
  <div>
    <form @submit.prevent="submitForm">
      <h2 :class="style['user-title']">
        {{ $t('sign_in') }}
      </h2>

      <figure role="group">
        <p :class="style['chat-message']">
          {{ $t('new_session.information') }}
        </p>
        <figure-caption-user :settings="settings" />
      </figure>

      <label for="email" :class="style['user-label']">
        <input
          id="email"
          v-model="inputEmail"
          type="email"
          autofocus
          placeholder=" "
          :class="style['user-input']"
          @input="errorMessage = ''"
        />

        <span :class="style['field-name']">
          {{ $t('new_session.email_placeholder') }}
        </span>
      </label>

      <label for="pw" :class="style['user-label']">
        <input
          id="pw"
          v-model="inputPassword"
          type="password"
          placeholder=" "
          :class="style['user-input']"
          @input="errorMessage = ''"
        />

        <span :class="style['field-name']">
          {{ $t('new_session.password_placeholder') }}
        </span>

        <span :class="style['forgot-link']" @click="goToUserComponent('ForgotPassword')">
          {{ $t('user_top.forgot_password') }}
        </span>
      </label>
      <p :class="style['error-text']">{{ errorMessage }}</p>

      <input
        type="submit"
        :class="[style['user-input'], style['submit-button']]"
        :value="$t('sign_in')"
        :disabled="isSending"
      />
      <p :class="style['t-r']">
        {{ $t('user_top.or') }}&nbsp;
        <a href="#" @click.prevent="goToUserComponent('SignUp')">
          {{ $t('sign_up') }}
        </a>
      </p>
    </form>

    <span class="text-divider">&nbsp;</span>

    <facebook-login-button />
  </div>
</template>

<script>
import { User } from 'src/apis'
import { termsAndConditionURL } from 'javascript/Constants'
import { EventBus } from 'ChatWidget/EventBus'
import FigureCaptionUser from './FigureCaptionUser.vue'
import FacebookLoginButton from 'javascript/ChatWidget/UtilityComponents/FacebookLoginButton'
import style from './scss/_users.scss'
import { useAppStore } from 'Store/app'

export default {
  components: {
    FigureCaptionUser,
    FacebookLoginButton
  },

  setup() {
    return {
      appStore: useAppStore()
    }
  },

  props: {
    settings: { type: Object, required: true },
    closeUserPanel: { type: Function, required: true },
    goToUserComponent: { type: Function, required: true }
  },
  data: function () {
    return {
      errorMessage: '',
      inputEmail: '',
      inputPassword: '',
      isSending: false,
      style,
      termsAndConditionURL
    }
  },

  methods: {
    submitForm() {
      this.isSending = true
      User.SignInKnownUser({
        email: this.inputEmail,
        password: this.inputPassword,
        successful_auth_auto_message_id: this.appStore.autoMessageAuthId
      })
        .then((json) => {
          this.errorMessage = ''
          this.closeUserPanel()
          EventBus.$emit('refresh-login', json)
          this.appStore.setMinimized(false)
        })
        .catch((error) => {
          this.isSending = false
          if (error.xhr.status === 404) {
            this.errorMessage = this.$t('new_session.error_message.email')
          } else if (error.xhr.status === 405) {
            this.errorMessage = this.$t('new_session.error_message.known_user_different')
          }
          console.error('sign in error here: ', error)
        })
    }
  }
}
</script>
